import { rem } from 'polished';
import React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';

interface ReviewsProps {
  reviewTexts: any[];
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${rem(10)};
  margin: ${rem(10)} ${rem(15)} ${rem(50)} ${rem(15)};

  ${({ theme }) => theme.media('md')} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const ReviewWrapper = styled.div`
  padding: ${rem(20)};
  background-color: #f1f8fe;

  ${({ theme }) => theme.media('sm')} {
    padding: ${rem(20)} ${rem(30)} ${rem(20)} ${rem(30)};
  }
`;

const ReviewHeading = styled.div`
  display: flex;
  align-items: center;
`;

const ReviewHeadingText = styled.span`
  font-size: ${rem(20)};
`;

const ReviewHeadingTextWithImage = styled(ReviewHeadingText)`
  margin-left: ${rem(10)};
`;

const ReviewContent = styled.div``;

const GoogleLogo = styled.img`
  height: ${rem(30)};
`;

const FacebookLogo = styled.img`
  height: ${rem(18)};
  margin-bottom: ${rem(3)};
`;

export const Reviews = (props: ReviewsProps) => {
  const { reviewTexts } = props;

  const HOMEPAGE_REVIEW_GOOGLE = reviewTexts?.find(
    (item) => item.text_id === 'HOMEPAGE_REVIEW_GOOGLE',
  )?.content?.json_content?.body;
  const HOMEPAGE_REVIEW_FACEBOOK = reviewTexts?.find(
    (item) => item.text_id === 'HOMEPAGE_REVIEW_FACEBOOK',
  )?.content?.json_content?.body;
  const HOMEPAGE_REVIEW_AFTER_ORDER = reviewTexts?.find(
    (item) => item.text_id === 'HOMEPAGE_REVIEW_AFTER_ORDER',
  )?.content?.json_content?.body;

  return (
    <Wrapper>
      {HOMEPAGE_REVIEW_GOOGLE && typeof HOMEPAGE_REVIEW_GOOGLE === 'string' ? (
        <ReviewWrapper>
          <ReviewHeading>
            <GoogleLogo src="/images/icons/google-full.png" />
            <ReviewHeadingTextWithImage>
              {' '}
              {__('recenzie')}{' '}
            </ReviewHeadingTextWithImage>
          </ReviewHeading>
          <ReviewContent>
            <div dangerouslySetInnerHTML={{ __html: HOMEPAGE_REVIEW_GOOGLE }} />
          </ReviewContent>
        </ReviewWrapper>
      ) : (
        <></>
      )}

      {HOMEPAGE_REVIEW_FACEBOOK &&
      typeof HOMEPAGE_REVIEW_FACEBOOK === 'string' ? (
        <ReviewWrapper>
          <ReviewHeading>
            <FacebookLogo src="/images/icons/facebook-full.png" />
            <ReviewHeadingTextWithImage>
              {' '}
              {__('recenzie')}{' '}
            </ReviewHeadingTextWithImage>
          </ReviewHeading>
          <ReviewContent>
            <div
              dangerouslySetInnerHTML={{ __html: HOMEPAGE_REVIEW_FACEBOOK }}
            />
          </ReviewContent>
        </ReviewWrapper>
      ) : (
        <></>
      )}

      {HOMEPAGE_REVIEW_AFTER_ORDER &&
      typeof HOMEPAGE_REVIEW_AFTER_ORDER === 'string' ? (
        <ReviewWrapper>
          <ReviewHeading>
            <ReviewHeadingText>
              {' '}
              {__('Hodnotenia po nákupe')}{' '}
            </ReviewHeadingText>
          </ReviewHeading>
          <ReviewContent>
            <div
              dangerouslySetInnerHTML={{ __html: HOMEPAGE_REVIEW_AFTER_ORDER }}
            />
          </ReviewContent>
        </ReviewWrapper>
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
